import React from 'react';

import Link from '@dashboard/components/mui-atoms/Link';
import { Box, Card, CardActionArea, CardContent, CardMedia, Stack } from '@mui/material';

type Props = {
  href: string;
  image: JsxNode;
  children: JsxNode;
};

const IMAGE_WIDTH = 128;
const IMAGE_HEIGHT = 96;

export default function DisplayComponent({ href, image, children }: Props) {
  return (
    <Card sx={{ boxShadow: 0 }}>
      <CardActionArea component={Link} href={href}>
        <Stack direction="row" sx={{ alignItems: 'center' }}>
          <Box>
            <CardMedia
              src="iframe"
              sx={{
                width: IMAGE_WIDTH,
                height: IMAGE_HEIGHT,
                backgroundPosition: 'top',
                position: 'relative',
              }}
            >
              {image}
              <Box sx={{ position: 'absolute', top: 0, right: 0, left: 0, bottom: 0 }} />
            </CardMedia>
          </Box>
          <CardContent sx={{ width: '100%' }}>{children}</CardContent>
        </Stack>
      </CardActionArea>
    </Card>
  );
}
